import * as moment from "moment";
import {i18n} from '@/plugins/i18n';

const Observationstatus = {
    setStatus(sensor, obs, sensorobs){
      
      sensor = this.setOnlineStatus(sensor, obs);

      //Getting all qc flags
      //Not implemented yet
      
      sensor = this.setSensorType(sensor, sensorobs);

      return sensor;

    },
    //Check and set status according to date for last measurement
    setOnlineStatus(sensor, obs){
        let sobs = obs.filter(o => o.id === sensor.id);

        if(sobs.length > 0){
            //max timestamp_from_epoch
            let maxObj = sobs.reduce((max, obj) => (max.timestamp_from_epoch > obj.timestamp_from_epoch) ? max : obj);
            let date = moment(maxObj.timestamp_from_epoch * 1000).utc();
            //More than 72 h ago
            if(date.isBefore( moment().utc().subtract(72, 'hours'), 'hours')){
                sensor = this.setSensorStatus(sensor, 3, {text: i18n.t('online72h'), lastdate: date});
            }
            //6 hours ago
            else if(date.isBefore(moment().utc().subtract(6, 'hours'), 'hours')){
                sensor = this.setSensorStatus(sensor, 2, {text: i18n.t('online6h'), lastdate: date});
            }
            //2 hours ago
            else if(date.isBefore(moment().utc().subtract(2, 'hours'), 'hours')){
                sensor = this.setSensorStatus(sensor, 1, {text: i18n.t('online2h'), lastdate: date});
            }
            //Found online
            else{
                sensor = this.setSensorStatus(sensor, 0, {text: i18n.t('online'), lastdate: date});
                sensor.onlinedata = true;
            }
        }
        else{
            sensor = this.setSensorStatus(sensor, 3, {text: i18n.t('nomeasurements'), lastdate: null});
        }
        return sensor;
    },

    //Check and set status according to fan speed
    setFanSpeedStatus(sensor, sobs){

        //We only asked for 1 parameter
      if(sobs.length === 1){
        if(sobs[0].AggObservations.length > 0 ){
          let maxObj = sobs[0].AggObservations.reduce((max, obj) => (max.avg > obj.avg) ? max : obj);
          if(maxObj.avg === 0){
            sensor = this.setSensorStatus(sensor, 3, {text: maxObj.avg});
          }
          else if(maxObj.avg >= 14000){
            sensor = this.setSensorStatus(sensor, 0, {text: maxObj.avg});
          }
          else if(maxObj.avg >= 11000){
            sensor = this.setSensorStatus(sensor, 1, {text: maxObj.avg});
          }
          else{
            sensor = this.setSensorStatus(sensor, 2, {text: maxObj.avg});
          }
        }
      }
      else
        return sensor;
    },
    //Check if mobile or static sensors and set location on sensor object if mobile sensor from measurements
    setSensorType(sensor, obs){
         //sensor units that have varying location will not have their lat,lon,alt values on the sensor object but must be found in their latest observations 
         sensor.staticsensor = true;
         if(sensor.location === null){ //indicates that this is a mobile sensor
           sensor.staticsensor = false;
           let s = obs.find(x => x.id === sensor.id);  
           if(s !== undefined){
             sensor.location =  {
               "longitude": s.longitude,
               "latitude": s.latitude,
               "altitude": s.altitude
             };
           }
         }

         return sensor;
    },           
    setSensorStatus(sensor, statuscolor, statustext){
        sensor.statuscolor = statuscolor;
        sensor.statustext.push(statustext);

        return sensor;
      },    

};

export default Observationstatus;
